import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import $ from 'jquery';

import { parseMarkdownToHtml } from 'webapp/utils/html';

import didUpdate from 'webapp/modifiers/did-update';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

import type Account from 'webapp/services/account';

interface Args {
	text: string;
	isOpen: boolean;
	onToggleHelpbox: (isOpen: boolean) => void;
}

export default class FieldHelpboxComponent extends Component<Args> {
	@service declare account: Account;

	get formattedText(): string {
		const options = {
			text: this.args.text,
			hideHelpArticles: this.account.hideHelpArticles,
		};

		return parseMarkdownToHtml(options);
	}

	@action
	resize(node: HTMLElement): void {
		if (node) {
			$(node).closest('.item').trigger('resize');
		}
	}

	@action
	open(): void {
		this.args.onToggleHelpbox(true);
	}

	@action
	close(): void {
		this.args.onToggleHelpbox(false);
	}
	<template>
		<div class="helpbox {{if @isOpen 'open' 'closed'}}" {{didUpdate this.resize @isOpen}}>
			{{#if @isOpen}}
				<div>
					<CommonUiIconComponent @name="InfoFill" @size="sm" />
					<strong>Quick help</strong>
					<p class="content">{{{this.formattedText}}}</p>

					<span
						role="button"
						class="helpbox__close"
						{{on "click" this.close}}
					><CommonUiIconComponent @name="Close" @size="sm" />
					</span>
				</div>

			{{else}}
				<span
					role="button"
					class="helpbox__trigger"
					{{on "click" this.open}}
				><CommonUiIconComponent @name="InfoFill" @size="sm" />
				</span>
			{{/if}}

		</div>
	</template>
}
